import { getUserContext } from '@cbhq/client-analytics';
import type { Client } from '@cbhq/error-vitals-web';
import { init } from '@cbhq/error-vitals-web';

import { appVersion, releaseStage, sentryDsn, targetEnvironment } from '../configs/environments';

let errorVitalsClient: Client | null = null;

export function initErrorVitals(): Client {
  if (errorVitalsClient) {
    return errorVitalsClient;
  }

  errorVitalsClient = init({
    apiKey: sentryDsn,
    environment: releaseStage,
    appVersion,
    appName: 'workspace',
    useGlobalHandlers: targetEnvironment !== 'local',
    maxEvents: 50,
    getUserContext,
  });

  return errorVitalsClient;
}

export function getErrorVitalsClient(): Client | null {
  return errorVitalsClient;
}

export function setErrorVitalsUser(userId: string): void {
  errorVitalsClient?.setGlobalMetadata({ userId });
}
